//customer
export const FETCH_COST_SUCCESS = 'FETCH_COST_SUCCESS';
export const FETCH_COST_PENDING = 'FETCH_COST_PENDING';
export const FETCH_COST_ERROR = 'FETCH_COST_ERROR';
export const FETCH_COST = 'FETCH_COST';

